import { FadeIn } from "./FadeIn";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES_DATA } from "../data/services";

export const Services = () => (
  <section id="hizmetler" data-testid="services-section" className="relative py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <FadeIn>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber-400 mb-4">
          Ustalık Hizmetleri
        </p>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-50 max-w-2xl leading-tight">
          Tüm elektrik işleriniz. <span className="text-slate-500">Temiz, garantili, net.</span>
        </h2>
      </FadeIn>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
        {SERVICES_DATA.map((s, i) => (
          <FadeIn key={s.slug} delay={i * 0.08} className={s.span}>
            <Link
              to={`/hizmet/${s.slug}`}
              data-testid={`service-card-${i}`}
              className="group relative block h-full min-h-[300px] rounded-3xl overflow-hidden border border-slate-800 bg-[#0F172A] hover:border-amber-500/50 transition-colors duration-300"
            >
              <img
                src={s.image}
                alt={`Beylikdüzü ${s.shortTitle}`}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-55 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#070A0F] via-[#070A0F]/55 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-7 sm:p-8">
                <span className="inline-flex w-fit rounded-full border border-amber-500/40 bg-amber-500/10 px-3 py-1 font-mono text-[10px] tracking-[0.2em] text-amber-400 uppercase mb-4">
                  {s.tag}
                </span>
                <div className="flex items-end justify-between gap-4">
                  <div>
                    <h3 className="font-display font-bold text-xl sm:text-2xl text-slate-50 tracking-tight">
                      {s.title}
                    </h3>
                    <p className="mt-2 text-sm text-slate-400 leading-relaxed max-w-md">{s.cardDesc}</p>
                  </div>
                  <span className="shrink-0 flex items-center justify-center w-11 h-11 rounded-full border border-slate-700 text-slate-400 group-hover:bg-amber-500 group-hover:border-amber-500 group-hover:text-black transition-all duration-300">
                    <ArrowUpRight className="w-5 h-5" strokeWidth={2.25} />
                  </span>
                </div>
              </div>
            </Link>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);
